export const WizardStep = {
    ARR: 'ARR',
    DEP: 'DEP',
    LOAD_FUEL: 'LOAD_FUEL',
    NAV_ROUTE: 'NAV_ROUTE',
    START: 'START',
    TOTAL: 'TOTAL',
};

export const StepName = {
    [WizardStep.ARR]: 'flightPage.wizardStep.arr',
    [WizardStep.DEP]: 'flightPage.wizardStep.dep',
    [WizardStep.LOAD_FUEL]: 'flightPage.wizardStep.loadFuel',
    [WizardStep.NAV_ROUTE]: 'flightPage.wizardStep.navRoute',
    [WizardStep.START]: 'flightPage.wizardStep.start',
    [WizardStep.TOTAL]: 'flightPage.wizardStep.total',
};

export const StepNumber = {
    [WizardStep.START]: 0,
    [WizardStep.LOAD_FUEL]: 1,
    [WizardStep.DEP]: 2,
    [WizardStep.NAV_ROUTE]: 3,
    [WizardStep.ARR]: 4,
    [WizardStep.TOTAL]: 5,
};
